import { render, staticRenderFns } from "./ProductShoppingCart.vue?vue&type=template&id=4ba18ea9"
import script from "./ProductShoppingCart.vue?vue&type=script&lang=js"
export * from "./ProductShoppingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports